module.exports = __webpack_public_path__ + "static/Slide01@1x.5c17d288.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide01@1x.png
// module id = 702
// module chunks = 216210090109534